<template>
    <div>
      <bread-crumb></bread-crumb>
      <div class="import-box">
        <div class="left">
          <!-- {{ JSON.stringify() }} -->
          <!-- <div>导入案例信息：{{type == 1 ? "(药品) " : "(sku) "}}<input type="file" @change="fileChange" ref="file"/></div> -->
          <div>导入案例信息：{{typeList[type] }}<input type="file" @change="fileChange" ref="file"/></div>
          <p>导入限制5M大小，最大支持1000条数据！！！</p>
        </div>
        <el-button type="primary" size="medium" :loading="uploadShow" @click="uploadCategoryExl">
          {{ uploadShow ? '上传中' : '上传' }}
        </el-button>
        <el-button size="medium"  @click="downloadCategoryExl" >
          下载最新模板
        </el-button>
      </div>
    </div>
  </template>
  
  <script>
    import { fileChange } from "../../components/importExportCommon";
    import breadCrumb from "../../../../components/breadCrumb";
    import {health_pgc_queryExportTemplate, pcdDrugQueryImport, pcdSkuQueryImport,
      pcdDrugImportQuestionAndAnswer,pcdSkuImportQuestionAndAnswer,
      pcdChildImportQuestionAndAnswer,pcdPetImportQuestionAndAnswer,
      pcdDrugExportQuestionAndAnswer, pcdSkuExportQuestionAndAnswer} from '../../../../api/man.js';
    
    export default {
      name: "pgcImport",
      components:{
        breadCrumb
      },
      data() {
        return {
          uploadShow: false,
          type:new URLSearchParams(window.location.search).get('type'),
          typeList: ['', '(药品) ', '(SKU) ', '(宠物案例管理SKU) ', '(婴幼儿用户案例管理SKU) '],
        }
      },
      methods:{
        // 上传文件校验
        async fileChange(e) {
          fileChange(e, this, 5);
        },
        // 导入商品
        async uploadCategoryExl() {
          let file = this.fileName
          if (file == "" || !file) {
            this.$message.error('请选择上传的文件');
            return false
          } else {
            this.uploadShow = true
            this.$message({
              message: '文件上传中，请勿刷新页面和关闭窗口！',
              type: 'warning'
            });
          }
          if(this.type == 1) {
             pcdDrugImportQuestionAndAnswer({
              tenantId: this.$commonJs.getTenantId(),
              fileBase64: this.fileBase64,
              fileName: file.name.split(".")[0],
            }).then(res=>{
              console.log('pcdDrugImportQuestionAndAnswer', res);
              if(res) {
                this.uploadShow = false;
                this.$message({
                  message: '上传成功',
                  type:'success'
                })
                setTimeout(() => {
                  this.$router.push({
                    path: '/pgc/record'
                  })
                }, 300);
              }
            }).catch(e=>{
              if (!e.success) {
                this.$message.error(e?.msg || '上传失败, 请检查网络或文件');
                this.uploadShow = false;
              }
              console.log(e, 'ppppppp=======>');
            })
          } else if( this.type == 2) {
            pcdSkuImportQuestionAndAnswer({
              tenantId: this.$commonJs.getTenantId(),
              fileBase64: this.fileBase64,
              fileName: file.name.split(".")[0],
            }).then(res=>{
              console.log('pcdSkuImportQuestionAndAnswer', res);
              if(res) {
                this.uploadShow = false;
                this.$message({
                  message: '上传成功',
                  type:'success'
                })
                setTimeout(() => {
                  this.$router.push({
                    path: '/pgc/record'
                  })
                }, 300);
              }
            }).catch(e=>{
              if (!e.success) {
                this.$message.error(e?.msg || '上传失败, 请检查网络或文件');
                this.uploadShow = false;
              }
              console.log(e, 'ppppppp=======>');
            })
          } else if(this.type == 3) {
            pcdPetImportQuestionAndAnswer({
              tenantId: this.$commonJs.getTenantId(),
              fileBase64: this.fileBase64,
              fileName: file.name.split(".")[0],
            }).then(res=>{
              console.log('pcdPetImportQuestionAndAnswer', res);
              if(res) {
                this.uploadShow = false;
                this.$message({
                  message: '上传成功',
                  type:'success'
                })
                setTimeout(() => {
                  this.$router.push({
                    path: '/pgc/record'
                  })
                }, 300);
              }
            }).catch(e=>{
              if (!e.success) {
                this.$message.error(e?.msg || '上传失败, 请检查网络或文件');
                this.uploadShow = false;
              }
              console.log(e, 'ppppppp=======>');
            })
          } else if(this.type == 4) {
            pcdChildImportQuestionAndAnswer({
              tenantId: this.$commonJs.getTenantId(),
              fileBase64: this.fileBase64,
              fileName: file.name.split(".")[0],
            }).then(res=>{
              console.log('pcdChildImportQuestionAndAnswer', res);
              if(res) {
                this.uploadShow = false;
                this.$message({
                  message: '上传成功',
                  type:'success'
                })
                setTimeout(() => {
                  this.$router.push({
                    path: '/pgc/record'
                  })
                }, 300);
              }
            }).catch(e=>{
              if (!e.success) {
                this.$message.error(e?.msg || '上传失败, 请检查网络或文件');
                this.uploadShow = false;
              }
              console.log(e, 'ppppppp=======>');
            })
          }
          // this.type == 1 ?
          // pcdDrugImportQuestionAndAnswer({
          //     tenantId: this.$commonJs.getTenantId(),
          //     fileBase64: this.fileBase64,
          //     fileName: file.name.split(".")[0],
          //   }).then(res=>{
          //     console.log('pcdDrugImportQuestionAndAnswer', res);
          //     if(res) {
          //       this.uploadShow = false;
          //       this.$message({
          //         message: '上传成功',
          //         type:'success'
          //       })
          //       setTimeout(() => {
          //         this.$router.push({
          //           path: '/pgc/record'
          //         })
          //       }, 300);
          //     }
          //   }).catch(e=>{
          //     if (!e.success) {
          //       this.$message.error(e?.msg || '上传失败, 请检查网络或文件');
          //       this.uploadShow = false;
          //     }
          //     console.log(e, 'ppppppp=======>');
          //   }):
          //   pcdSkuImportQuestionAndAnswer({
          //     tenantId: this.$commonJs.getTenantId(),
          //     fileBase64: this.fileBase64,
          //     fileName: file.name.split(".")[0],
          //   }).then(res=>{
          //     console.log('pcdSkuImportQuestionAndAnswer', res);
          //     if(res) {
          //       this.uploadShow = false;
          //       this.$message({
          //         message: '上传成功',
          //         type:'success'
          //       })
          //       setTimeout(() => {
          //         this.$router.push({
          //           path: '/pgc/record'
          //         })
          //       }, 300);
          //     }
          //   }).catch(e=>{
          //     if (!e.success) {
          //       this.$message.error(e?.msg || '上传失败, 请检查网络或文件');
          //       this.uploadShow = false;
          //     }
          //     console.log(e, 'ppppppp=======>');
          //   })
        },
        // 下载模板
        downloadCategoryExl(){
            let typeValue = '';
            if (Number(this.type) == 1) {
              typeValue = 2;
            } else if(Number(this.type) == 2) {
              typeValue = 3;
            } else if(Number(this.type) == 3) {
              typeValue = 7;
            } else if(Number(this.type) == 4) {
              typeValue = 6;
            }
            health_pgc_queryExportTemplate({
                // type: Number(this.type) === 2 ? 2: 3
                type: typeValue
              }).then((res)=>{
                console.log("====?",res)
                if(res){
                  window.location.href = res;
                }else{
                  this.$alert("未请求到模版地址")
                }
              }).catch(err=>{
                this.$alert(err)
              })
          }
      }
    }
  </script>
  
  <style lang="scss" scoped>
  .import-box{
    padding: 20px 0 20px 33px;
    background: #fff;
    box-shadow: 0 0 6px rgba(229,227,227,0.79);
    overflow: hidden;
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .left {
      font-size: 14px;
      min-width: 400px;
      p {
        color: red;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  </style>
  